import { merchantKnowledgeArticleSchema } from "@redotech/shopper-agent-knowledge-common/merchant-knowledge-view";
import { merchantKnowledgeIdFormat } from "@redotech/shopper-agent-knowledge-id";
import * as z from "zod";

/** Articles by id. Ids that no longer resolve are absent, never blank. */
export const getKnowledgeArticles = {
  name: "getKnowledgeArticles" as const,
  input: z.object({ ids: z.array(merchantKnowledgeIdFormat.schema) }),
  output: z.array(merchantKnowledgeArticleSchema),
};
